<template>
  <div class="exam-content-rs">
    <div class="title">
      You will hear a sentence. Please repeat the sentence exactly as you hear
      it. You will hear the sentence only once.
    </div>
    <div class="audio">
      <Audio :url="detail.audio.url" :onInit="handleAudioInit" />
    </div>

    <div class="ques-answer">
      <div>
        <label>答题记录:</label>
        <span><AudioMini :url="examInfo.user_answer"/></span>
      </div>
    </div>
  </div>
</template>

<script>
import Audio from '../../components/audio'
import AudioMini from '@/components/Audio/Audio.vue'
import api from '@/api/exam'

export default {
  components: {
    Audio,
    AudioMini
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    examInfo: {
      type: Object,
      default: () => ({})
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      recoredWaitTime: 0
    }
  },
  methods: {
    handleAudioInit(audioTime, waitTime) {
      this.recoredWaitTime = Math.round(audioTime + waitTime + 30)
    }
  }
}
</script>

<style scoped lang="scss">
.exam-content-rs {
  color: #1f1f40;
  padding-bottom: 24px;
  .title {
    margin-top: 24px;
    font-size: 16px;
    font-weight: bold;
  }
  .record {
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }
  .audio {
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }
  .ques-answer {
    padding: 16px;
    margin-top: 30px;
    background-color: #f6f6f6;
    border-radius: 10px;
    > div {
      display: flex;
      align-items: center;
      margin-top: 8px;
      &:first-child {
        margin-top: 0;
      }
      > label {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 68px;
        padding: 0 10px;
        height: 24px;
        background-color: #dcdcdc;
        border-radius: 20px;
        font-size: 16px;
        color: #9c9c9c;
      }
      > span {
        margin-left: 16px;
        color: #1f1f40;
        font-size: 18px;
        flex: 1;
      }
    }
  }
}
</style>
